{
  "filters": {
    "filters": {
      "salesRep": {
        "field": "sales_rep",
        "label": "Sales Rep",
        "type": "multi",
        "source": "api",
        "column": "sales_rep",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "product": {
        "field": "product",
        "label": "Product",
        "type": "multi",
        "source": "api",
        "column": "product",
        "fetchDistinct": true,
        "orderDirection": "asc",
        "defaultValue": [
          "60LG25D",
          "60LG40D",
          "60LG50DW",
          "60S230D",
          "60S280D",
          "60S330D",
          "60S460D",
          "60S660D",
          "10USEDCON1",
          "10USEDCON2",
          "10USEDCON3",
          "10USEDCON4",
          "10USEDCON5",
          "10USEDCON6",
          "10USEDCON7",
          "10USEDCON8",
          "10USEDCON9",
          "10USEDCON10",
          "10USEDEQ4",
          "10USEDEQ5"
        ],
        "defaultOperator": "not_in"
      },
      "bandPosition": {
        "field": "band_position",
        "label": "Band Position",
        "type": "multi",
        "source": "api",
        "column": "band_position",
        "fetchDistinct": true,
        "orderDirection": "asc",
        "isSearchable": false,
        "defaultValue": ["No Guidance", "Allredi Guidance"],
        "defaultOperator": "not_in"
      },
      "taxonomy1": {
        "field": "taxonomy_1",
        "label": "Taxonomy 1",
        "type": "multi",
        "source": "api",
        "column": "taxonomy_1",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "salesTeam": {
        "field": "sales_team",
        "label": "Sales Team",
        "type": "multi",
        "source": "api",
        "column": "sales_team",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "customerName": {
        "field": "customer_name",
        "label": "Customer Name",
        "type": "multi",
        "source": "api",
        "column": "customer_name",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "groupCustomerName": {
        "field": "group_customer_name",
        "label": "Group Customer Name",
        "type": "multi",
        "source": "api",
        "column": "group_customer_name",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "productGroupRollup": {
        "field": "product_group_rollup",
        "label": "Product Group Rollup",
        "type": "multi",
        "source": "api",
        "column": "product_group_rollup",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "homeBaseRegion": {
        "field": "home_base_pricing_region",
        "label": "Home Base Pricing Region",
        "type": "multi",
        "source": "api",
        "column": "home_base_pricing_region",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "stockFacilityName": {
        "field": "stock_facility_name",
        "label": "Stocking Facility",
        "type": "multi",
        "source": "api",
        "column": "stock_facility_name",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "customerNumber": {
        "field": "customer_number",
        "label": "Customer Number",
        "type": "multi",
        "source": "api",
        "column": "customer_number",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "priceFamily": {
        "field": "price_family",
        "label": "Price Family",
        "type": "multi",
        "source": "api",
        "column": "price_family",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "customerSize": {
        "field": "allredi_customer_size",
        "label": "Customer Size",
        "type": "multi",
        "source": "api",
        "column": "allredi_customer_size",
        "fetchDistinct": true,
        "orderDirection": "asc",
        "isSearchable": false
      },
      "orderWriter": {
        "field": "order_writer",
        "label": "Order Writer",
        "type": "multi",
        "source": "api",
        "column": "order_writer",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "minDate": {
        "field": "min_date",
        "label": "Date",
        "type": "multi",
        "source": "api",
        "column": "min_date",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "taxonomy0": {
        "field": "taxonomy_0",
        "label": "Taxonomy 0",
        "type": "multi",
        "source": "api",
        "column": "taxonomy_0",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "rvp": {
        "field": "rvp",
        "label": "RVP",
        "type": "multi",
        "source": "api",
        "column": "rvp",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "pricingTier": {
        "field": "customer_pricing_tier",
        "label": "Customer Pricing Tier",
        "type": "multi",
        "source": "api",
        "column": "customer_pricing_tier",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "transactionId": {
        "field": "transaction_id",
        "label": "Transaction",
        "type": "multi",
        "source": "api",
        "column": "transaction_id",
        "fetchDistinct": true,
        "orderDirection": "asc"
      }
    }
  },
  "pages": {
    "home": {
      "features": {
        "metrics": {
          "registry": {
            "Average Margin": {
              "id": "average_margin",
              "display": {
                "label": "Average Margin",
                "showPercentageChange": true,
                "type": "percentage",
                "unit": "pts",
                "isPercentagePointMetric": true
              }
            },
            "Total Revenue": {
              "id": "total_revenue",
              "display": {
                "label": "Total Revenue",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Total Transactions": {
              "id": "total_transactions",
              "display": {
                "label": "Total Transactions",
                "showPercentageChange": true,
                "type": "quantity"
              }
            },
            "Average Price": {
              "id": "average_unit_price",
              "display": {
                "label": "Average Price",
                "showPercentageChange": true,
                "type": "price"
              }
            }
          },
          "selection": {
            "defaultMetricIds": [
              "average_margin",
              "total_revenue",
              "total_transactions",
              "average_unit_price"
            ],
            "allAvailableMetricIds": [
              "average_margin",
              "total_revenue",
              "total_transactions",
              "average_unit_price"
            ],
            "persistSelection": false
          }
        }
      }
    },
    "sales-rep-performance": {
      "features": {
        "metrics": {
          "registry": {
            "Profit Per Rep": {
              "id": "profit_per_rep",
              "display": {
                "label": "Profit Per Rep",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Revenue Per Rep": {
              "id": "revenue_per_rep",
              "display": {
                "label": "Revenue Per Rep",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Number Of New Deals": {
              "id": "total_transactions",
              "display": {
                "label": "Number Of New Deals",
                "showPercentageChange": true,
                "type": "quantity"
              }
            },
            "Margin": {
              "id": "average_margin",
              "display": {
                "label": "Margin",
                "showPercentageChange": true,
                "type": "percentage",
                "unit": "pts",
                "isPercentagePointMetric": true
              }
            }
          },
          "selection": {
            "defaultMetricIds": [
              "total_transactions",
              "revenue_per_rep",
              "profit_per_rep",
              "average_margin"
            ],
            "allAvailableMetricIds": [
              "total_transactions",
              "revenue_per_rep",
              "profit_per_rep",
              "average_margin"
            ],
            "persistSelection": false,
            "ordering": [
              "average_margin",
              "revenue_per_rep",
              "profit_per_rep",
              "total_transactions"
            ]
          }
        },
        "tables": {
          "registry": {
            "sales-reps": {
              "id": "sales-reps",
              "label": "Sales Rep Performance",
              "defaultSortField": "revenue",
              "defaultSortOrder": -1,
              "pageSize": 10,
              "chunkSize": 50,
              "columns": [
                {
                  "field": "repName",
                  "header": "Sales Rep",
                  "type": "text",
                  "sortable": true,
                  "clickable": true,
                  "avatar": true,
                  "align": "left",
                  "minWidth": "240px"
                },
                {
                  "field": "revenue",
                  "header": "Revenue",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "margin",
                  "header": "Margin",
                  "type": "percent",
                  "sortable": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "marginAmount",
                  "header": "Profit",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "averageDealSize",
                  "header": "Avg. Deal Size",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "numberOfTransactions",
                  "header": "Transactions",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "categories",
                  "header": "Categories",
                  "type": "integer",
                  "sortable": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "productsSold",
                  "header": "Products Sold",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "volume",
                  "header": "Volume",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "numberOfCustomers",
                  "header": "Number of Customers",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "averageUnitPrice",
                  "header": "Average Price",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "abbreviate": false,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                }
              ],
              "fieldMappings": [
                {
                  "backend": "rep_name",
                  "ui": "repName",
                  "dbFieldName": "sales_rep"
                },
                {
                  "backend": "total_revenue",
                  "ui": "revenue",
                  "transform": "number"
                },
                {
                  "backend": "margin_percent",
                  "ui": "margin",
                  "transform": "number"
                },
                {
                  "backend": "total_margin_dollars",
                  "ui": "marginAmount",
                  "transform": "number"
                },
                {
                  "backend": "avg_deal_size",
                  "ui": "averageDealSize",
                  "transform": "number"
                },
                {
                  "backend": "num_transactions",
                  "ui": "numberOfTransactions"
                },
                {
                  "backend": "num_categories",
                  "ui": "categories"
                },
                {
                  "backend": "num_products_sold",
                  "ui": "productsSold"
                },
                {
                  "backend": "total_volume",
                  "ui": "volume",
                  "transform": "number"
                },
                {
                  "backend": "number_of_customers",
                  "ui": "numberOfCustomers"
                },
                {
                  "backend": "price_over_volume",
                  "ui": "averageUnitPrice",
                  "transform": "number"
                }
              ]
            }
          }
        }
      }
    },
    "customer-performance": {
      "features": {
        "metrics": {
          "registry": {
            "Profit Per Customer": {
              "id": "profit_per_customer",
              "display": {
                "label": "Profit Per Customer",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Revenue Per Customer": {
              "id": "revenue_per_customer",
              "display": {
                "label": "Revenue Per Customer",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Number Of Active Customers": {
              "id": "total_active_customers",
              "display": {
                "label": "Number Of Active Customers",
                "showPercentageChange": true,
                "type": "quantity"
              }
            },
            "Margin": {
              "id": "average_margin",
              "display": {
                "label": "Margin",
                "showPercentageChange": true,
                "type": "percentage",
                "unit": "pts",
                "isPercentagePointMetric": true
              }
            }
          },
          "selection": {
            "defaultMetricIds": [
              "total_active_customers",
              "revenue_per_customer",
              "profit_per_customer",
              "average_margin"
            ],
            "allAvailableMetricIds": [
              "total_active_customers",
              "revenue_per_customer",
              "profit_per_customer",
              "average_margin"
            ],
            "persistSelection": false,
            "ordering": [
              "average_margin",
              "revenue_per_customer",
              "profit_per_customer",
              "total_active_customers"
            ]
          }
        },
        "tables": {
          "registry": {
            "customer-performance": {
              "id": "customer-performance",
              "label": "Customer Performance",
              "defaultSortField": "revenue",
              "defaultSortOrder": -1,
              "pageSize": 10,
              "chunkSize": 50,
              "columns": [
                {
                  "field": "customerName",
                  "header": "Customer Name",
                  "type": "text",
                  "sortable": true,
                  "clickable": true,
                  "avatar": true,
                  "align": "left",
                  "minWidth": "300px"
                },
                {
                  "field": "revenue",
                  "header": "Revenue",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "margin",
                  "header": "Margin",
                  "type": "percent",
                  "sortable": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "marginAmount",
                  "header": "Profit",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "averageDealSize",
                  "header": "Avg. Deal Size",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "numberOfTransactions",
                  "header": "Transactions",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "categories",
                  "header": "Categories",
                  "type": "integer",
                  "sortable": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "productsSold",
                  "header": "Products Sold",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "volume",
                  "header": "Volume",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "averageUnitPrice",
                  "header": "Average Price",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "abbreviate": false,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                }
              ],
              "fieldMappings": [
                {
                  "backend": "customer_name",
                  "ui": "customerName"
                },
                {
                  "backend": "total_revenue",
                  "ui": "revenue",
                  "transform": "number"
                },
                {
                  "backend": "margin_percent",
                  "ui": "margin",
                  "transform": "number"
                },
                {
                  "backend": "total_margin_dollars",
                  "ui": "marginAmount",
                  "transform": "number"
                },
                {
                  "backend": "avg_deal_size",
                  "ui": "averageDealSize",
                  "transform": "number"
                },
                {
                  "backend": "num_transactions",
                  "ui": "numberOfTransactions"
                },
                {
                  "backend": "num_categories",
                  "ui": "categories"
                },
                {
                  "backend": "num_products_sold",
                  "ui": "productsSold"
                },
                {
                  "backend": "total_volume",
                  "ui": "volume",
                  "transform": "number"
                },
                {
                  "backend": "price_over_volume",
                  "ui": "averageUnitPrice",
                  "transform": "number"
                }
              ]
            }
          }
        }
      }
    },
    "product-performance": {
      "features": {
        "metrics": {
          "registry": {
            "Margin": {
              "id": "average_margin",
              "display": {
                "label": "Margin",
                "showPercentageChange": true,
                "type": "percentage",
                "unit": "pts",
                "isPercentagePointMetric": true
              }
            },
            "Products Growing": {
              "id": "products_growing",
              "display": {
                "label": "Products Growing",
                "showPercentageChange": true,
                "type": "percentage"
              }
            },
            "Avg Customer Penetration": {
              "id": "average_customers_per_product",
              "display": {
                "label": "Avg. Customer Penetration",
                "showPercentageChange": true,
                "type": "quantity"
              }
            },
            "Products In Decline": {
              "id": "products_decline",
              "display": {
                "label": "Products In Decline",
                "showPercentageChange": true,
                "type": "percentage"
              }
            }
          },
          "selection": {
            "defaultMetricIds": [
              "average_margin",
              "products_growing",
              "average_customers_per_product",
              "products_decline"
            ],
            "allAvailableMetricIds": [
              "average_margin",
              "products_growing",
              "average_customers_per_product",
              "products_decline"
            ],
            "persistSelection": false,
            "ordering": [
              "average_margin",
              "products_growing",
              "average_customers_per_product",
              "products_decline"
            ]
          }
        },
        "tables": {
          "registry": {
            "product-performance": {
              "id": "product-performance",
              "label": "Product Performance",
              "defaultSortField": "revenue",
              "defaultSortOrder": -1,
              "pageSize": 10,
              "chunkSize": 50,
              "columns": [
                {
                  "field": "product",
                  "header": "Product",
                  "type": "text",
                  "sortable": true,
                  "clickable": true,
                  "avatar": true,
                  "avatarType": "icon",
                  "avatarIcon": "pi pi-building",
                  "align": "left",
                  "minWidth": "280px"
                },
                {
                  "field": "revenue",
                  "header": "Revenue",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "margin",
                  "header": "Margin",
                  "type": "percent",
                  "sortable": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "marginAmount",
                  "header": "Profit",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "averageDealSize",
                  "header": "Avg. Deal Size",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "numberOfTransactions",
                  "header": "Transactions",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "volume",
                  "header": "Volume",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "customerCount",
                  "header": "Number of Customers",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "averagePrice",
                  "header": "Average Price",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                },
                {
                  "field": "averageCost",
                  "header": "Avg. Cost",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true,
                  "align": "right",
                  "paddingClass": "pad-2rem"
                }
              ],
              "fieldMappings": [
                {
                  "backend": "product",
                  "ui": "product"
                },
                {
                  "backend": "total_revenue",
                  "ui": "revenue",
                  "transform": "number"
                },
                {
                  "backend": "margin_percent",
                  "ui": "margin",
                  "transform": "number"
                },
                {
                  "backend": "total_margin_dollars",
                  "ui": "marginAmount",
                  "transform": "number"
                },
                {
                  "backend": "avg_deal_size",
                  "ui": "averageDealSize",
                  "transform": "number"
                },
                {
                  "backend": "num_transactions",
                  "ui": "numberOfTransactions"
                },
                {
                  "backend": "customer_count",
                  "ui": "customerCount"
                },
                {
                  "backend": "total_volume",
                  "ui": "volume",
                  "transform": "number"
                },
                {
                  "backend": "avg_price",
                  "ui": "averagePrice",
                  "transform": "number"
                },
                {
                  "backend": "avg_cost",
                  "ui": "averageCost",
                  "transform": "number"
                }
              ]
            }
          }
        }
      }
    }
  }
}
